import { fromUtf8 } from '../../../../utils/utf8.js';
import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgCW20Send extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgCW20Send(params);
    }
    toData() {
        const { params } = this;
        return {
            contract: params.contractAddress,
            amount: params.amount,
            msg: Buffer.from(fromUtf8(JSON.stringify(params.msg || {}))).toString('base64'),
        };
    }
    toExecData() {
        return dataToExecData('send', this.toData());
    }
}
